import { useCallback } from 'react';

import { Platform } from 'react-native';

import { getVersion } from 'react-native-device-info';
import { useSelector } from 'react-redux';

import { DEVICE_TYPE } from 'config/api';

import { selectConsentMask } from 'store/config/selectors.ts';
import {
    selectAccountId,
    selectActiveUserProfile,
    selectClientId,
} from 'store/user/selectors';

import { isWeb } from 'utils/responsiveness';

import { version } from '../../../package.json';
import { UavBaseParams, UavEvents } from './types';

function useGetBaseUavParams() {
    const accountId = useSelector(selectAccountId);
    const deviceId = useSelector(selectClientId);
    const selectedProfileId = useSelector(selectActiveUserProfile);
    const consentMask = useSelector(selectConsentMask);
    const appVersion = Platform.select({
        web: version,
        default: getVersion(),
    });

    return useCallback(
        (name: UavEvents): UavBaseParams | undefined => {
            if (accountId && deviceId) {
                return {
                    key: '',
                    userId: selectedProfileId || '',
                    accountId,
                    deviceId,
                    name,
                    timestamp: new Date().toISOString(),
                    metadata: {
                        appName: isWeb ? 'OneTV_Web' : 'OneTV_Mobiles',
                        appVersion,
                        deviceType: DEVICE_TYPE,
                        consentMask,
                    },
                };
            }

            return undefined;
        },
        [accountId, deviceId, selectedProfileId, consentMask],
    );
}

export default useGetBaseUavParams;
